import Button from "../components/common/Button";
import Image from "../components/common/Image";
import DOMPurify from 'dompurify'

function SliderItem(props) {
  const lang = props.lang;

  const newsColors = [
    {bg: 'tw-bg-teal-dark', fc: "tw-text-white", bc: "orange"}, 
    {bg:'tw-bg-teal-light', fc: "tw-text-white", bc: "white"}, 
    {bg:'tw-bg-yellow',  fc: "tw-text-teal", bc: "teal-ghost"}];

  let classNames =
    "tw-h-[25em] md:tw-h-[28em] tw-w-72 ipad:tw-w-auto ipad:tw-relative tw-rounded-lg ipad:tw-rounded-2xl tw-bg-gray-medium tw-overflow-hidden tw-group tw-block " +
    props.className;

  let subheadStyle = {wordBreak:'keep-all'};

  return (
    <a className={classNames} href={props.button[lang].href}>
      <div className={"tw-h-[70%] tw-relative tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-p-5 tw-pt-0 tw-pb-5 "+newsColors[props.sliderBG%3].bg}>
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-start tw-mt-8 tw-flex-1 ">
          <p
            className={"tw-max-w-full tw-font-italic tw-text-2xl premd:tw-text-3xl ipad:tw-text-xl ipdad:leading-4 tw-uppercase tw-leading-none "+newsColors[props.sliderBG%3].fc}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.title[lang]) }}
          ></p>
          <p style={subheadStyle}
            className={"tw-mb-[-1em] md:tw-mb-0  tw-max-w-full tw-text-sm tw-leading-5 md:tw-leading-5 tw-mt-1 "+newsColors[props.sliderBG%3].fc}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.subtitle[lang]) }}
          ></p>
        </div>
        <Button
          title={props.button[lang].label}
          color={newsColors[props.sliderBG].bc}
          size="small"
          className="tw-mt-4 tw-w-full active:tw-border-transparent"
        />
      </div>

      <Image
        className="tw-h-[30%] tw-w-full tw-object-cover tw-block tw-bg-gray-medium"
        src={props.image[lang]}
      />
    </a>
  );
}

export default SliderItem;
